"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createErrorNotificationStyle;

function createErrorNotificationStyle(_ref) {
  var connectivityIconPadding = _ref.connectivityIconPadding,
      connectivityMarginLeftRight = _ref.connectivityMarginLeftRight,
      connectivityMarginTopBottom = _ref.connectivityMarginTopBottom,
      connectivityTextSize = _ref.connectivityTextSize,
      failedConnectivity = _ref.failedConnectivity,
      primaryFont = _ref.primaryFont;
  return {
    alignItems: 'center',
    color: failedConnectivity,
    display: 'flex',
    fontFamily: primaryFont,
    fontSize: connectivityTextSize,
    fontWeight: 'bold',
    marginBottom: connectivityMarginTopBottom,
    marginLeft: connectivityMarginLeftRight,
    marginRight: connectivityMarginLeftRight,
    marginTop: connectivityMarginTopBottom,
    '& > svg': {
      fill: failedConnectivity,
      '&:not(.webchat__error--rtl)': {
        paddingRight: connectivityIconPadding
      },
      '.webchat__error--rtl': {
        paddingLeft: connectivityIconPadding
      }
    }
  };
}